export const DeliveryManColumns = [
  { 
    field: "_id", 
    header: "User Id",
    accessor: (row,handleCellClick) => (
        <>
          <div onClick={()=>handleCellClick(row,"_id")}  className="cursor-pointer text-blue-600 hover:text-blue-800">
            <p>{row?._id}</p>            
          </div>
        </>
      ),

   },
  { 
    field: "Name", 
    header: "name",
    accessor: (row) => (
        <>
          <div  className="cursor-pointer">
            
            <p className="truncate w-[8rem]">{row?.firstName} {row?.lastName}</p>            
          </div>
        </>
      ),

   },
  
  { field: "status", header: "Status",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.availability?.status}
          </p>
        </div>
      </>
    ),
   },
  { field: "phoneNumber", header: "Contact No",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.phoneNumber}
          </p>
        </div>
      </>
    ),
   },
  
  { field: "ratings", header: "Rating",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.ratings?.average}
          </p>
        </div>
      </>
    ),
   },
   { field: "vehicleType", header: "vehicleType",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.vehicleType}
          </p>
        </div>
      </>
    ),
   },
  
];


export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export  const filters = [
    {
      filterType: "Delivery Type",
      inputName: "order_type",
      options: [
        {
          name: "Local delivery",
          code: "LOCAL DELIVERY",
        },
        {
          name: "Intercity delivery",
          code: "INTERCITY DELIVERY",
        },
      ],
    },
   
  ]
  
  export const canlenderFilter={
    filterType:"Order Date",
    inputName:"order_date",  
    maxDate :new Date()
  }
  
  
  
  
   
  


export default {  
    filters:filters,
    SearchBy:searchBy  ,
    // WeekRange:WeekRange,
    // MonthRange:MonthRange,
    canlenderFilter:canlenderFilter,    
  }